import React from "react";
import { TColor, TTypographyVariant } from "../../../types";
import Flex from "../../Flex";
import { Typography } from "../../Typography";
import { TCheckboxSize } from "./helpers";
import * as S from "./styled";

export interface ICheckboxBaseProps {
    defaultChecked?: boolean;
    type: "checkbox" | "radio";
    checked?: boolean;
    label?: React.ReactNode;
    labelColor: TColor;
    labelSize: TTypographyVariant;
    helperText?: React.ReactNode;
    helperTextSize: TTypographyVariant;
    disabled?: boolean;
    trackName: string;
    trackData?: Record<string, unknown>;
    onChange?: (value: boolean, event?: React.ChangeEvent<HTMLInputElement>) => void;
    size?: TCheckboxSize;
    renderIcon: (checked: boolean) => React.ReactNode;
}

const CheckboxBase: React.FC<ICheckboxBaseProps> = ({
    type,
    disabled = false,
    defaultChecked = false,
    checked: checkedProp,
    label,
    helperText,
    onChange,
    renderIcon,
    size = "sm",
    labelColor,
    labelSize,
    helperTextSize
}) => {
    const [checkedState, setChecked] = React.useState(defaultChecked);
    const checked: boolean = checkedProp ?? checkedState;
    const withLabel: boolean = !!(label || helperText);

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(!checked, event);
    };

    return (
        <S.Wrapper $disabled={disabled} $checked={checked} $size={size} $withLabel={withLabel}>
            <S.HiddenInput
                type={type}
                checked={checked}
                onChange={e => {
                    setChecked(e.target.checked);
                    handleChange(e);
                }}
                disabled={disabled}
            />
            {renderIcon(checked)}
            {withLabel && (
                <Flex direction="column" gap="2px">
                    {label && (
                        <Typography variant={labelSize} color={labelColor}>
                            {label}
                        </Typography>
                    )}
                    {helperText && (
                        <Typography variant={helperTextSize} color="text-primary-700">
                            {helperText}
                        </Typography>
                    )}
                </Flex>
            )}
        </S.Wrapper>
    );
};

export default CheckboxBase;
